import { useQuery } from "react-query";
import { ICategoryList } from "../../types/Categories.types";

import { QueryParams } from "../../enums/QueryParams";
import { Endpoints } from "../../enums/Endpoints";
import { smartbizUrl } from "../ApiClient";

const { BUSINESS_CATEGORIES } = Endpoints;
const { CATEGORIES_KEY } = QueryParams;
export const getAllBusinessCategories = async (): Promise<ICategoryList> => {
  const response = (await smartbizUrl.get(`/${BUSINESS_CATEGORIES}`))?.data;
  return response;
};

const useGetBusinessCategoriesQuery = () => {
  const fetchAllBusinessCategories = (): Promise<ICategoryList> =>
    getAllBusinessCategories();
  const { isLoading, error, data, refetch } = useQuery(
    [CATEGORIES_KEY],
    fetchAllBusinessCategories,
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
  return { isLoading, error, data, refetch };
};

export default useGetBusinessCategoriesQuery;
